<template>
  <section
    class="component-b9a1af4d"
    resmed-component-name="promo_fullwidth_text_2cta"
    v-bind:style="styles"
  >
    <div
      class="component"
      v-bind:class="[`text-color-${acf.layout['text-color']}`]"
    >
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center">
          <div class="col col-md-11 col-lg-10 col-xl-9 text-center">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="'center'"
            ></eyebrow-icon>
            <h2 v-html="acf.headline"></h2>
            <div v-if="acf.content" v-html="acf.content" class="content"></div>

            <div v-if="acf.cta" class="cta mt-4">
              <!-- modal brightcove player -->
              <a
                v-if="acf.modal.player && acf.cta.length === 1"
                href="#"
                class="btn cta-pill filled-red icon right-arrow"
                v-bind:modal-video-id="acf.modal.id"
                v-on:click.prevent="modal(acf.modal.player, acf.modal.id)"
                >{{ acf.cta[0].cta.text }}</a
              >

              <!-- modal form. cpap store. get listed -->
              <a
                v-if="acf.modal.form && acf.cta.length === 1"
                href="#"
                class="btn cta-pill filled-red icon right-arrow"
                v-on:click.prevent="$emit('getlisted:active', true)"
                >{{ acf.cta[0].cta.text }}</a
              >

              <!-- default cta -->
              <a
                v-if="
                  !acf.modal.player && !acf.modal.form && acf.cta.length >= 1
                "
                v-for="item in acf.cta"
                v-bind:href="item.cta.href"
                v-bind:target="item.cta.target"
                class="btn cta-pill icon right-arrow mr-3"
                v-bind:class="{
                  [`${acf.layout.cta}-white`]:
                    acf.layout['text-color'] === 'white' ||
                    !acf.layout['text-color'], // white or undefined
                  [`${acf.layout.cta}-red`]:
                    acf.layout['text-color'] === 'black',
                }"
                >{{ item.cta.text }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal. form - get listed -->
    <getlisted>
      <h2>{{ acf.modal["form-headline"] }}</h2>
      <p>{{ acf.modal["form-description"] }}</p>
    </getlisted>
  </section>
</template>

<script>
import getlisted from "../shared-support/modal-b9a1af4d";

export default {
  name: "component-b9a1af4d", // promo_fullwidth_text_2cta
  props: ["acf"],
  components: {
    getlisted,
  },
  data() {
    return {
      styles: {
        "background-color": this.acf.layout["background-color"],
        "background-size": this.acf.layout["background-size"],
      },
    };
  },
  watch: {
    "$root.mode": {
      handler(val) {
        this.$set(
          this.styles,
          "background-image",
          `url(${this.acf.layout["background-image"]})`
        );

        if (
          ["xs", "sm"].includes(val) &&
          this.acf.layout["background-image-xs"]
        ) {
          this.$set(
            this.styles,
            "background-image",
            `url(${this.acf.layout["background-image-xs"]})`
          );
        }
      },
      immediate: true,
    },
  },
  methods: {
    modal(...arg) {
      bus.$emit("overlay:active", {
        active: true,
        player: arg[0],
        id: arg[1],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-b9a1af4d {
  background-position: center center;
  background-repeat: no-repeat;
  padding: 6rem 0 5rem 0;

  @media (min-width: 768px) {
    padding: 6rem;
  }

  @media (min-width: 992px) {
    padding: 7rem 0;
  }

  @media (min-width: 1200px) {
    padding: 8rem 0;
  }
}

.component {
  h2 {
    position: relative;
    margin: 0 0 1rem 0;
    color: $cc-resmed-white;

    @extend %eyebrow-center;
    &:before {
      background-color: $cc-resmed-white;
    }
  }

  .cta {
    > a {
      margin: 0 0.5rem;
    }
  }
}
</style>

<style lang="scss">
@import "../../css/abstracts/colors";

.component-b9a1af4d {
  .component {
    &.text-color-black {
      h2 {
        color: $cc-resmed-black;

        &:before {
          background-color: $cc-resmed-black;
        }
      }

      .content {
        color: $cc-resmed-black;
      }
    }

    .content {
      color: $cc-resmed-white;
    }
  }
}
</style>